export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-shrink-0">
            <img
              src="https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20mockup%20displaying%20a%20movie%20streaming%20app%20interface%20with%20film%20poster%20thumbnails%2C%20warm%20red%20and%20gold%20UI%20design%2C%20clean%20modern%20layout%2C%20no%20text%2C%20minimalist%20phone%20frame%2C%20app%20store%20style%20presentation%2C%20soft%20shadow%20on%20light%20surface&width=360&height=640&seq=app-mockup&orientation=portrait"
              alt="6080影院移动端观影体验"
              className="w-56 md:w-64 h-auto object-contain"
            />
          </div>

          <div className="flex-1 text-center lg:text-left">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
              <i className="ri-smartphone-line text-sm"></i>
              移动观影
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100 mb-3">
              随时随地，精彩不断
            </h2>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-6 max-w-lg">
              6080影院完美适配移动端，无需下载APP，手机浏览器直接访问就能享受高清在线影院级观影体验。
              躺在床上、通勤路上、午休时间，随时随地打开就能看，高清视频播放流畅不卡。
            </p>

            <div className="flex flex-wrap gap-3 justify-center lg:justify-start">
              <a
                href="#app"
                onClick={(e) => e.preventDefault()}
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 text-sm font-medium rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-android-line text-lg"></i>
                Android 版
              </a>
              <a
                href="#app"
                onClick={(e) => e.preventDefault()}
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-100 text-background-50 text-sm font-medium rounded-lg hover:bg-foreground-200 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-apple-line text-lg"></i>
                iOS 版
              </a>
              <a
                href="#app"
                onClick={(e) => e.preventDefault()}
                className="inline-flex items-center gap-2 px-5 py-2.5 border border-background-300 text-foreground-300 text-sm font-medium rounded-lg hover:border-primary-400 hover:text-primary-500 transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-window-line text-lg"></i>
                网页版
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}